<template>
  <div>
    <b-list-group class="organization-list">
      <b-list-group-item
        v-for="(membership, index) in memberships"
        :key="membership.id"
        :class="{ 'first' : index === 0, 'last' : index === memberships.length - 1 }"
        class="hover-item"
        @click="onClick(membership)">

        <b-container fluid>
          <b-row>

            <b-col cols="12" sm="6" class="name-wrapper">
              <h5>{{ membership.tenant.name }}</h5>
              <b-badge pill class="role" variant="secondary">{{ membership.role }}</b-badge>
              <b-badge v-if="!membership.is_active" pill class="role" variant="danger">suspended</b-badge>
            </b-col>

            <b-col cols="12" sm="6" class="info-wrapper">
              <span>
                <span v-b-tooltip.hover title="your modules">
                  <i class="fas fa-folder"></i>
                  {{ membership.modules.length }}
                </span>
                <span v-b-tooltip.hover title="your groups">
                  <i class="fas fa-users"></i>
                  {{ membership.groups.length }}
                </span>
              </span>

              <span v-b-tooltip.hover v-if="membership.role === 'master' || membership.role === 'admin'" style="display:inline-block" class="buttons" title="edit">
                <b-button
                  title="edit"
                  variant="outline-secondary"
                  @click.stop="edit(membership)">
                  <i class="fas fa-cog"></i>
                </b-button>
              </span>

            </b-col>
          </b-row>
        </b-container>

      </b-list-group-item>

      <b-modal v-model="confirmationModalShow" centered hide-footer title="Email Confirmation Required">
        <div class="d-block text-center">
          You must
          <router-link :to="{name: 'profile'}" style="text-decoration:underline">confirm your email</router-link>
          before accessing this organization.
        </div>
        <b-button class="mt-3" variant="outline-primary" block @click="confirmationModalShow = false">Close</b-button>
      </b-modal>

      <b-modal v-model="suspendedModalShow" centered hide-footer title="Membership Suspended">
        <div class="d-block text-center">
          Your membership with this organization has been suspended.
        </div>
        <b-button class="mt-3" variant="outline-primary" block @click="suspendedModalShow = false">Close</b-button>
      </b-modal>
    </b-list-group>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  data () {
    return {
      confirmationModalShow: false,
      suspendedModalShow: false,
      rowClickEnabled: true
    }
  },
  computed: {
    ...mapState('client', {
      client: 'data'
    }),
    ...mapGetters('client', {
      memberships: 'notDeletedMemberships'
    })
  },
  methods: {
    onClick (membership) {
      if (this.rowClickEnabled) {
        const granted = this.checkAccess(membership)

        if (granted) {
          this.$router.push({
            name: 'client-modules',
            params: {
              organization: membership.tenant.id
            }
          })
        }
      }
    },
    checkAccess (membership) {
      let granted = true

      // suspended account
      if (!membership.is_active) {
        this.suspendedModalShow = true
        granted = false

      // email confirmation required
      } else if (this.client.is_confirmed === 0) {
        this.confirmationModalShow = true
        granted = false
      }

      return granted
    },
    showModal (membership) {
      const ref = `userModal_${membership.tenant.id}`
      this.$refs[ref][0].show()
    },
    hideModal (membership) {
      const ref = `userModal_${membership.tenant.id}`
      this.$refs[ref][0].hide()
    },
    edit (membership) {
      const granted = this.checkAccess(membership)

      if (granted) {
        this.$router.push({
          name: 'admin-modules',
          params: {
            organization: membership.tenant.id
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

.organization-list {
  .buttons {
    margin-left: $spacing-sm;
  }

  .list-group-item {
    padding-left: 0;
    padding-right: 0;
    height: 4rem;
    display: flex;
    align-items: center;

    &.first {
      border-top-left-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }

    &.last {
      border-bottom-left-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }

    .role {
      margin-left: $spacing-xs;
    }

    .name-wrapper {
      display: flex;
      align-items:center;
      justify-content: flex-start;
    }

    .info-wrapper {
      display: flex;
      align-items:center;
      justify-content: flex-end;
    }

    @include media-breakpoint-down(xs) {
      .info-wrapper {
        margin-top: $spacing-xs;
        justify-content: flex-start;
      }
    }

    h5 {
      text-transform: capitalize;
      display: inline;
      margin: 0
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/home/your-organizations.vue